import Template1_A4WithHeader from './Template1_A4WithHeader';
import Template2_A4WithoutHeader from './Template2_A4WithoutHeader';
import Template3_SmallWithHeader from './Template3_SmallWithHeader';
import Template4_SmallWithoutHeader from './Template4_SmallWithoutHeader';
import Template5_CustomerCopy from './Template5_CustomerCopy';
import Template6_HeaderImageUpload from './Template6_HeaderImageUpload';
import Template7_WithQRCode from './Template7_WithQRCode';
import Template8_WithWatermark from './Template8_WithWatermark';
import { InvoiceTemplateProps } from './types';

export type TemplateId = 
  | 'a4' 
  | 'a4-no-header' 
  | 'small' 
  | 'small-no-header' 
  | 'customer-copy' 
  | 'header-upload' 
  | 'theme-7' 
  | 'theme-8'
  | 'lab-copy'; // Legacy support

export const TemplateRegistry: Record<TemplateId, React.ComponentType<InvoiceTemplateProps>> = {
  'a4': Template1_A4WithHeader,
  'a4-no-header': Template2_A4WithoutHeader,
  'small': Template3_SmallWithHeader,
  'small-no-header': Template4_SmallWithoutHeader,
  'customer-copy': Template5_CustomerCopy,
  'header-upload': Template6_HeaderImageUpload,
  'theme-7': Template7_WithQRCode,
  'theme-8': Template8_WithWatermark,
  'lab-copy': Template5_CustomerCopy, // Legacy: map to customer-copy
};

export function getTemplateComponent(templateId: string): React.ComponentType<InvoiceTemplateProps> {
  if (templateId === 'lab-copy') {
    return TemplateRegistry['customer-copy'];
  }
  
  return TemplateRegistry[templateId as TemplateId] || TemplateRegistry['a4'];
}
